module.exports = __webpack_public_path__ + "media/common/images/GasNet_logo_zelena-59febe3744d74e811befa5b55fa9564c.png";